<div class="auth-Layout">
  <!-- if unchangeUrl is true, it means that this component was open in another one -->
  @if ((mobile  && !setting.navigationSetting) && setting.configuration.uIoptions && !unchangeUrl) {
    <app-undocked-navigation-bar style="position: relative; z-index: 10;" [disabledOption]="title"></app-undocked-navigation-bar>
  }

  <div class="top-image">
    <img style="width: 100%;" src="assets/tempimgs/glazing-login-page.png" alt="">
  </div>

  @if(loginTab == true) {
    <div class="content-layout">
      <div class="title-content">
        <h1 class="auth-title">{{'AllInOneAuth.Login' | translate}}</h1>
        <p class="auth-description">{{'AllInOneAuth.Desc' | translate}}</p>
        <div class="auth-half-line-through"></div>
      </div>
      <form class="auth-form-content" (ngSubmit)="submitLogin()">

        <div class="email-input">
          <h3 class="input-title">{{'Courriel'}}</h3>
          <div class="input-layout">
            <div class="input-container">
              <div class="input-format">
                <ion-icon class="input-icon" slot="start" [ios]="'mail-outline'" [md]="'mail-outline'" ></ion-icon>
                <div class="input-Seperator"></div>
                <div class="input-group">
                  <!--<input type="text" [(ngModel)]="email" placeholder=" " required />-->
                  <input type="email" name="email" [(ngModel)]="email" placeholder="Entrez votre courriel ici" #emailCtrl="ngModel" required 
                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                    [class.valid]="emailCtrl.valid && (emailCtrl.dirty || emailCtrl.touched)"
                    [class.invalid]="emailCtrl.invalid && (emailCtrl.dirty || emailCtrl.touched)" />
                  <!--<label>Email</label>-->
                </div>
              </div>
            </div>
            @if(emailCtrl.invalid && emailCtrl.touched) {
              <div class="error">
                {{'AllInOneAuth.ErrEmail' | translate}}
              </div>
            }
            
            <div class="line-through"></div>
          </div>
        </div>

        <div class="password-input">
          <h3 class="input-title">{{'AllInOneAuth.Password' | translate}}</h3>
          <div class="input-layout">
            <div class="input-container">
              <div class="input-format">
                <ion-icon class="input-icon" slot="start" [ios]="'lock-closed-outline'" [md]="'lock-closed-outline'" ></ion-icon>
                <div class="input-Seperator"></div>
                <div class="input-group">
                  <!--<input type="password" [(ngModel)]="password" placeholder=" " required />-->
                  <input [type]="viewpassword ? 'text' : 'password'" name="password" [(ngModel)]="password" placeholder="Entrez votre mot de passe ici" #passwordCtrl="ngModel" required 
                    [class.valid]="passwordCtrl.valid && (passwordCtrl.dirty || passwordCtrl.touched)"
                    [class.invalid]="passwordCtrl.invalid && (passwordCtrl.dirty || passwordCtrl.touched)"/>
                    <!-- backup pattern: pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"  -->

                  <!--<label>Password</label>-->
                </div>
              </div>
              
              
              <!--need to fine a new icon to match homers-->
              @if(viewpassword) {
                <!--<div class="hide-passe-icon"></div>-->
                <ion-icon class="eye-icon" slot="start" [ios]="'eye-outline'" [md]="'eye-sharp'" (click)="togglePasswordView('login')"></ion-icon>
              } @else {
                <!--<div class="hide-passe-icon"></div>-->
                <ion-icon class="eye-icon" slot="start" [ios]="'eye-off-outline'" [md]="'eye-off-sharp'" (click)="togglePasswordView('login')"></ion-icon> 
              }
              
            </div>

            @if(passwordCtrl.invalid && passwordCtrl.touched) {
              <div class="error">
                {{'AllInOneAuth.ErrPass' | translate}}
              </div>
            }
            <div class="line-through"></div>
          </div>
        </div>

        <div class="additional-options">
          <div class="remember-me">
            <ion-checkbox [(ngModel)]="rememberMe"></ion-checkbox>
            <span>{{'AllInOneAuth.RememberMe' | translate}}</span>
          </div>
          <div class="forgot-password-selectable" (click)="gotoforgottenPassword()">
            {{'AllInOneAuth.ForgotPassword' | translate}}
          </div>
        </div>

        <div class="login-button-container">
          <button type="submit" class="login-button" [disabled]="emailCtrl.invalid || passwordCtrl.invalid || !emailCtrl.dirty || !passwordCtrl.dirty">{{'AllInOneAuth.LoginBtn' | translate}}</button>
        </div>

        <div class="subscribe-suggestion-container">
          {{'AllInOneAuth.NoAccount' | translate}} <span class="subscribe-suggestion-link" (click)="gotoAccountRegistration()">{{'AllInOneAuth.Subscribe' | translate}}</span>
        </div>
      </form>
    </div>
  } @else if (registrationTab == true) {
    <div class="content-layout">
      <div class="title-content">
        <h1 class="auth-title">{{'AllInOneAuth.SubscribeTitle' | translate}}</h1>
        <p class="auth-description">{{'AllInOneAuth.SubDesc' | translate}}</p>
        <div class="auth-half-line-through"></div>
      </div>
      @if(registrationStep == 'email') {
        <form class="auth-form-content" (ngSubmit)="startRegistration()">

          <div class="email-input">
            <h3 class="input-title">{{'AllInOneAuth.Email' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'mail-outline'" [md]="'mail-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="text" [(ngModel)]="email" placeholder=" " required />-->
                    <input type="email" name="emailRegister" [(ngModel)]="emailRegister" placeholder="Email" #emailRegisterCtrl="ngModel" required 
                      pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                      [class.valid]="emailRegisterCtrl.valid && (emailRegisterCtrl.dirty || emailRegisterCtrl.touched)"
                      [class.invalid]="emailRegisterCtrl.invalid && (emailRegisterCtrl.dirty || emailRegisterCtrl.touched)" />
                    <!--<label>Email</label>-->
                  </div>
                </div>
              </div>
              @if(emailRegisterCtrl.invalid && emailRegisterCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.ErrEmail' | translate}}
                </div>
              }
              
              <div class="line-through"></div>
            </div>
          </div>

          <div class="additional-options">
            <div class="forgot-password-selectable" (click)="gotoforgottenPassword()">
                {{'AllInOneAuth.ForgotPassword' | translate}}
              </div>
            <div class="forgot-password-selectable" (click)="gotologin()">
              {{'AllInOneAuth.LoginToAccount' | translate}}
            </div>
          </div>

          <div class="login-button-container">
            <button type="submit" class="login-button" [disabled]="emailRegisterCtrl.invalid || !emailRegisterCtrl.dirty">{{'AllInOneAuth.Register' | translate}}</button>
          </div>
        </form>
      } @else if(registrationStep == 'memberCard') {
        <form class="auth-form-content" (ngSubmit)="memberCardRegistration()">

           <div class="email-input">
            <h3 class="input-title">{{'AllInOneAuth.AddMemberCard' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'mail-outline'" [md]="'mail-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="text" [(ngModel)]="email" placeholder=" " required />-->
                    <input type="string" name="memberCard" [(ngModel)]="memberCard" placeholder="Member card number" #memberCardCtrl="ngModel" required 
                      pattern="^[0-9]{6}$"
                      [class.valid]="memberCardCtrl.valid && (memberCardCtrl.dirty || memberCardCtrl.touched)"
                      [class.invalid]="memberCardCtrl.invalid && (memberCardCtrl.dirty || memberCardCtrl.touched)" />
                    <!--<label>Email</label>-->
                  </div>
                </div>
              </div>
              @if(memberCardCtrl.invalid && memberCardCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.EnterCodeFormat' | translate}}
                </div>
              }
              
              <div class="line-through"></div>
            </div>
          </div>
 
          <div class="additional-options">
            <div class="forgot-password-selectable" (click)="gotoforgottenPassword()">
              {{'AllInOneAuth.ForgotPassword' | translate}}
            </div>
            <div class="forgot-password-selectable" (click)="gotologin()">
              {{'AllInOneAuth.LoginToAccount' | translate}}
            </div>
          </div>

          <div class="login-button-container">
            <button type="submit" class="login-button" [disabled]="memberCardCtrl.invalid || !memberCardCtrl.dirty">{{'AllInOneAuth.MemberCard' | translate}}</button>
          </div>
        </form>
      } @else if(registrationStep == 'registration') {
        <form class="auth-form-content" (ngSubmit)="RegistrationProcess()">

          <div class="email-input">
            <h3 class="input-title">{{'AllInOneAuth.VerificationCode' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'mail-outline'" [md]="'mail-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="text" [(ngModel)]="email" placeholder=" " required />-->
                    <input type="string" name="randomCode" [(ngModel)]="randomCode" placeholder="Emailed code" #randomCodeCtrl="ngModel" required 
                      pattern="^[0-9]{6}$"
                      [class.valid]="randomCodeCtrl.valid && (randomCodeCtrl.dirty || randomCodeCtrl.touched)"
                      [class.invalid]="randomCodeCtrl.invalid && (randomCodeCtrl.dirty || randomCodeCtrl.touched)" />
                    <!--<label>Email</label>-->
                  </div>
                </div>
              </div>
              @if(randomCodeCtrl.invalid && randomCodeCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.EnterCodeFormat' | translate}}
                </div>
              }
              
              <div class="line-through"></div>
            </div>
          </div>

          <div class="password-input">
            <h3 class="input-title">{{'AllInOneAuth.FirstName' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'mail-outline'" [md]="'mail-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="text" [(ngModel)]="email" placeholder=" " required />-->
                    <input type="string" name="firstName" [(ngModel)]="firstName" placeholder="First Name" #firstNameCtrl="ngModel" required 
                      pattern="^[A-Za-zÀ-ÿ\s'-]+$"
                      [class.valid]="firstNameCtrl.valid && (firstNameCtrl.dirty || firstNameCtrl.touched)"
                      [class.invalid]="firstNameCtrl.invalid && (firstNameCtrl.dirty || firstNameCtrl.touched)" />
                    <!--<label>Email</label>-->
                  </div>
                </div>
              </div>
              @if(firstNameCtrl.invalid && firstNameCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.ErrName' | translate}}
                </div>
              }
              
              <div class="line-through"></div>
            </div>
          </div>

          <div class="password-input">
            <h3 class="input-title">{{'AllInOneAuth.LastName' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'mail-outline'" [md]="'mail-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="text" [(ngModel)]="email" placeholder=" " required />-->
                    <input type="string" name="lastName" [(ngModel)]="lastName" placeholder="Last name" #lastNameCtrl="ngModel" required 
                      pattern="^[A-Za-zÀ-ÿ\s'-]+$"
                      [class.valid]="lastNameCtrl.valid && (lastNameCtrl.dirty || lastNameCtrl.touched)"
                      [class.invalid]="lastNameCtrl.invalid && (lastNameCtrl.dirty || lastNameCtrl.touched)" />
                    <!--<label>Email</label>-->
                  </div>
                </div>
              </div>
              @if(lastNameCtrl.invalid && lastNameCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.ErrName' | translate}}
                </div>
              }
              
              <div class="line-through"></div>
            </div>
          </div>

          <div class="password-input">
            <h3 class="input-title">{{'AllInOneAuth.NewPass' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'lock-closed-outline'" [md]="'lock-closed-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="password" [(ngModel)]="password" placeholder=" " required />-->
                    <input [type]="viewpasswordNewRegistration ? 'text' : 'password'" name="registrationPassword" [(ngModel)]="registrationPassword" placeholder="Password" #registrationPasswordCtrl="ngModel" required 
                      [class.valid]="registrationPasswordCtrl.valid && (registrationPasswordCtrl.dirty || registrationPasswordCtrl.touched)"
                      [class.invalid]="registrationPasswordCtrl.invalid && (registrationPasswordCtrl.dirty || registrationPasswordCtrl.touched)"/>
                      <!-- backup pattern: pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"  -->

                    <!--<label>Password</label>-->
                  </div>
                </div>
                
                
                @if(viewpassword) {
                  <!--<div class="hide-passe-icon"></div>-->
                  <ion-icon class="eye-icon" slot="start" [ios]="'eye-outline'" [md]="'eye-sharp'" (click)="togglePasswordView('ResetPassNewReg')"></ion-icon>
                } @else {
                  <!--<div class="hide-passe-icon"></div>-->
                  <ion-icon class="eye-icon" slot="start" [ios]="'eye-off-outline'" [md]="'eye-off-sharp'" (click)="togglePasswordView('ResetPassNewReg')"></ion-icon> 
                }
                
              </div>

              @if(registrationPasswordCtrl.invalid && registrationPasswordCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.ErrPass' | translate}}
                </div>
              }
              <div class="line-through"></div>
            </div>
          </div>

          <div class="password-input">
            <h3 class="input-title">{{'AllInOneAuth.ConfPass' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'lock-closed-outline'" [md]="'lock-closed-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="password" [(ngModel)]="password" placeholder=" " required />-->
                    <input [type]="viewpasswordConfirmRegistration ? 'text' : 'password'" name="confirmRegistrationPassword" [(ngModel)]="confirmRegistrationPassword" placeholder="Confirm password" #confirmRegistrationPasswordCtrl="ngModel" required 
                      [class.valid]="confirmRegistrationPasswordCtrl.valid && (confirmRegistrationPasswordCtrl.dirty || confirmRegistrationPasswordCtrl.touched)"
                      [class.invalid]="confirmRegistrationPasswordCtrl.invalid && (confirmRegistrationPasswordCtrl.dirty || confirmRegistrationPasswordCtrl.touched)"/>
                      <!-- backup pattern: pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"  -->

                    <!--<label>Password</label>-->
                  </div>
                </div>
                
                
                @if(viewpassword) {
                  <!--<div class="hide-passe-icon"></div>-->
                  <ion-icon class="eye-icon" slot="start" [ios]="'eye-outline'" [md]="'eye-sharp'" (click)="togglePasswordView('ConfirmPassReg')"></ion-icon>
                } @else {
                  <!--<div class="hide-passe-icon"></div>-->
                  <ion-icon class="eye-icon" slot="start" [ios]="'eye-off-outline'" [md]="'eye-off-sharp'" (click)="togglePasswordView('ConfirmPassReg')"></ion-icon> 
                }
                
              </div>

              @if(confirmRegistrationPasswordCtrl.invalid && confirmRegistrationPasswordCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.ErrPass' | translate}}
                </div>
              }
              <div class="line-through"></div>
            </div>
          </div>

          <div class="password-input">
            <h3 class="input-title">{{'AllInOneAuth.SendEmails' | translate}}</h3>

            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  
                  <!-- Icon -->
                  <ion-icon 
                    class="input-icon" 
                    name="settings-outline">
                  </ion-icon>

                  <div class="input-Seperator"></div>

                  <!-- Label + Toggle -->
                  <div class="input-group toggle-group">
                    <span class="toggle-label">{{'AllInOneAuth.AcceptEmails' | translate}}</span>

                    <!--
                    <ion-toggle
                      name="acceptEmails"
                      [(ngModel)]="acceptEmails">
                    </ion-toggle>
                    -->
                  </div>

                </div>
                <ion-toggle
                    name="acceptEmails"
                    [(ngModel)]="acceptEmails">
                  </ion-toggle>
              </div>

              <div class="line-through"></div>
            </div>
          </div>

          

          <div class="additional-options">
            <div class="forgot-password-selectable" (click)="gotoforgottenPassword()">
              {{'AllInOneAuth.ForgotPassword' | translate}}
            </div>
            <div class="forgot-password-selectable" (click)="gotologin()">
              {{'AllInOneAuth.LoginToAccount' | translate}}
            </div>
          </div>

          <div class="login-button-container">
            <button type="submit" class="login-button" 
            [disabled]="
            randomCodeCtrl.invalid || !randomCodeCtrl.dirty ||
            firstNameCtrl.invalid || !firstNameCtrl.dirty ||
            lastNameCtrl.invalid || !lastNameCtrl.dirty ||
            registrationPasswordCtrl.invalid || !registrationPasswordCtrl.dirty ||
            confirmRegistrationPasswordCtrl.invalid || !confirmRegistrationPasswordCtrl.dirty ||
            !passwordsMatch('Registration')
            ">{{'AllInOneAuth.CompleteRegistration' | translate}}</button>
          </div>
          @if(!passwordsMatch("Registration")) {
            <div class="error">
              {{'AllInOneAuth.PassMismatch' | translate}}
            </div>
          }
        </form>
      }
      
    </div>
    
  } @else if (paswwordResetTab == true) {
    <div class="content-layout">
      <div class="title-content">
        <h1 class="auth-title">{{'AllInOneAuth.RecoverPass' | translate}}</h1>
        <p class="auth-description">{{'AllInOneAuth.AttemptRecovery' | translate}}</p>
        <div class="auth-half-line-through"></div>
      </div>
      @if(!this.emailCodePassReset) {
        <form class="auth-form-content" (ngSubmit)="sendResetCode()">

          <div class="email-input">
            <h3 class="input-title">{{'AllInOneAuth.Email' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'mail-outline'" [md]="'mail-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="text" [(ngModel)]="email" placeholder=" " required />-->
                    <input type="email" name="emailReset" [(ngModel)]="emailReset" placeholder="Email" #emailResetCtrl="ngModel" required 
                      pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                      [class.valid]="emailResetCtrl.valid && (emailResetCtrl.dirty || emailResetCtrl.touched)"
                      [class.invalid]="emailResetCtrl.invalid && (emailResetCtrl.dirty || emailResetCtrl.touched)" />
                    <!--<label>Email</label>-->
                  </div>
                </div>
              </div>
              @if(emailResetCtrl.invalid && emailResetCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.ErrEmail' | translate}}
                </div>
              }
              
              <div class="line-through"></div>
            </div>
          </div>

          <div class="additional-options">
            <div class="forgot-password-selectable" (click)="gotoAccountRegistration()">
              {{'AllInOneAuth.RegisterAccount' | translate}}
            </div>
            <div class="forgot-password-selectable" (click)="gotologin()">
              {{'AllInOneAuth.LoginToAccount' | translate}}
            </div>
          </div>

          <div class="login-button-container">
            <button type="submit" class="login-button" [disabled]="emailResetCtrl.invalid || !emailResetCtrl.dirty">{{'AllInOneAuth.SendResetCode' | translate}}</button>
          </div>
        </form>
      } @else {
        <form class="auth-form-content" (ngSubmit)="changePassword()">

          <div class="email-input">
            <h3 class="input-title">{{'Code de récupération'}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'mail-outline'" [md]="'mail-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="text" [(ngModel)]="email" placeholder=" " required />-->
                    <input type="string" name="resetCode" [(ngModel)]="resetCode" placeholder="Emailed code" #resetCodeCtrl="ngModel" required 
                      pattern="^[0-9]{6}$"
                      [class.valid]="resetCodeCtrl.valid && (resetCodeCtrl.dirty || resetCodeCtrl.touched)"
                      [class.invalid]="resetCodeCtrl.invalid && (resetCodeCtrl.dirty || resetCodeCtrl.touched)" />
                    <!--<label>Email</label>-->
                  </div>
                </div>
              </div>
              @if(resetCodeCtrl.invalid && resetCodeCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.EnterCodeFormat' | translate}}
                </div>
              }
              
              <div class="line-through"></div>
            </div>
          </div>

          <div class="password-input">
            <h3 class="input-title">{{'AllInOneAuth.NewPass' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'lock-closed-outline'" [md]="'lock-closed-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="password" [(ngModel)]="password" placeholder=" " required />-->
                    <input [type]="viewpasswordNew ? 'text' : 'password'" name="newPassword" [(ngModel)]="newPassword" placeholder="newPassword" #newPasswordCtrl="ngModel" required 
                      [class.valid]="newPasswordCtrl.valid && (newPasswordCtrl.dirty || newPasswordCtrl.touched)"
                      [class.invalid]="newPasswordCtrl.invalid && (newPasswordCtrl.dirty || newPasswordCtrl.touched)"/>
                      <!-- backup pattern: pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"  -->

                    <!--<label>Password</label>-->
                  </div>
                </div>
                
                
                @if(viewpassword) {
                  <!--<div class="hide-passe-icon"></div>-->
                  <ion-icon class="eye-icon" slot="start" [ios]="'eye-outline'" [md]="'eye-sharp'" (click)="togglePasswordView('ResetPassNew')"></ion-icon>
                } @else {
                  <!--<div class="hide-passe-icon"></div>-->
                  <ion-icon class="eye-icon" slot="start" [ios]="'eye-off-outline'" [md]="'eye-off-sharp'" (click)="togglePasswordView('ResetPassNew')"></ion-icon> 
                }
                
              </div>

              @if(newPasswordCtrl.invalid && newPasswordCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.ErrPass' | translate}}
                </div>
              }
              <div class="line-through"></div>
            </div>
          </div>

          <div class="password-input">
            <h3 class="input-title">{{'AllInOneAuth.ConfPass' | translate}}</h3>
            <div class="input-layout">
              <div class="input-container">
                <div class="input-format">
                  <ion-icon class="input-icon" slot="start" [ios]="'lock-closed-outline'" [md]="'lock-closed-outline'" ></ion-icon>
                  <div class="input-Seperator"></div>
                  <div class="input-group">
                    <!--<input type="password" [(ngModel)]="password" placeholder=" " required />-->
                    <input [type]="viewpasswordConfirm ? 'text' : 'password'" name="confirmPassword" [(ngModel)]="confirmPassword" placeholder="confirmPassword" #confirmPasswordCtrl="ngModel" required 
                      [class.valid]="confirmPasswordCtrl.valid && (confirmPasswordCtrl.dirty || confirmPasswordCtrl.touched)"
                      [class.invalid]="confirmPasswordCtrl.invalid && (confirmPasswordCtrl.dirty || confirmPasswordCtrl.touched)"/>
                      <!-- backup pattern: pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"  -->

                    <!--<label>Password</label>-->
                  </div>
                </div>
                
                
                @if(viewpassword) {
                  <!--<div class="hide-passe-icon"></div>-->
                  <ion-icon class="eye-icon" slot="start" [ios]="'eye-outline'" [md]="'eye-sharp'" (click)="togglePasswordView('ConfirmPass')"></ion-icon>
                } @else {
                  <!--<div class="hide-passe-icon"></div>-->
                  <ion-icon class="eye-icon" slot="start" [ios]="'eye-off-outline'" [md]="'eye-off-sharp'" (click)="togglePasswordView('ConfirmPass')"></ion-icon> 
                }
                
              </div>

              @if(confirmPasswordCtrl.invalid && confirmPasswordCtrl.touched) {
                <div class="error">
                  {{'AllInOneAuth.ErrPass' | translate}}
                </div>
              }
              <div class="line-through"></div>
            </div>
          </div>

          <div class="additional-options">
            <div class="forgot-password-selectable" (click)="gotoAccountRegistration()">
              {{'AllInOneAuth.RegisterAccount' | translate}}
            </div>
            <div class="forgot-password-selectable" (click)="gotologin()">
              {{'AllInOneAuth.LoginToAccount' | translate}}
            </div>
          </div>

          <div class="login-button-container">
            <button type="submit" class="login-button" [disabled]="resetCodeCtrl.invalid || !resetCodeCtrl.dirty || !newPasswordCtrl.dirty || !newPasswordCtrl.dirty || !confirmPasswordCtrl.dirty || !confirmPasswordCtrl.dirty || !passwordsMatch('ResetPass')">{{'AllInOneAuth.UpdatePass' | translate}}</button>
          </div>
          @if(!passwordsMatch('ResetPass')) {
            <div class="error">
              {{'AllInOneAuth.NewAndConfMismatch' | translate}}
            </div>
          }
          <div class="subscribe-suggestion-container">
            {{'AllInOneAuth.NoCodeReceived' | translate}}<span class="subscribe-suggestion-link" (click)="notReceivedAnyCode()">{{'AllInOneAuth.Retry' | translate}}</span>
          </div>
        </form>
      }
      
    </div>
  }



  <!--this should only show up for the checkout-->
  @if(guestOption) {
    <div class="content-layout">
      <div class="login-button-container">
        <button type="submit" class="login-button" (click)="ContinueAsGuest()">{{'AllInOneAuth.ContinuAsGuest' | translate}}</button>
      </div>
    </div>
    
  }
  
</div>